import { createGlobalStyle } from 'styled-components';
import {
  primaryFont, wMedium, retina, maxWidth, maxTablet,
  maxMobile, secondaryFont, wMBold, primaryColor, maxWidth1300, minWidthApp,
  midWidthApp, appBgColor,
} from '../Utils/utilsStyle';

const FeedStyle = createGlobalStyle`
  .spotlight-wrapper{
   background-color: #fff;
   border-radius:16px;
   padding: 24px 24px;
   margin-bottom: 28px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius:12px;
      padding-top:16px;
      padding-bottom:16px;
    }
    @media all and (max-width: ${maxMobile} ) {
      padding: 24px 10px;
    }
    .progress-wrapper {
      padding:12px 0px !important;
    }
    .spotlight-article-show {
      .other-states-area {
        .states-widget-primary {
          position: relative;
          .currency {
            position: absolute;
            top: 4px;
            display: flex;
            width: inherit;
            justify-content: center;
            @media all and (max-width: ${minWidthApp}) {
              font-size: 8px;
            }
          }
          .state {
            margin: 6px 12px 2px 12px;
            @media all and (max-width: ${maxWidth}), ${retina} {
              margin: 12px 8px 2px 8px;
            }
            @media all and (max-width: ${minWidthApp}) {
              line-height: 18px;
            }
            @media all and (max-width: ${maxTablet}) {
              line-height: 14px;
            }
          }
        }
      }
    }
  }
  .title-heading{
    color:#67696A;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    font-size:18px;
    line-height:32px;
    display:block;
    margin: auto 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 14px;
    }
    @media all and (max-width: ${maxTablet}) {
      font-size: 12px;
    }
  }
  .see-all {
    display: flex;
    align-items: center;
    font-family: ${secondaryFont};
    font-size: 14px;
    font-weight: ${wMBold};
    line-height: 36px;
    color: ${primaryColor};
    cursor: pointer;
    svg {
      margin-left: 10px;
    }
  }
  .see-all:hover {
    color: ${primaryColor};
  }
  .filter-placeholder {
    &.disabledFilter {
      .tabs-wrapper {
        pointer-events: none;
        cursor: no-drop;
      }
      .global-tabs-item {
        background-color: ${appBgColor};
        opacity: 0.7;
      }
    }
  }
  .view-tabs {
    pointer-events: none;
    &.notdisabledTabs{
      pointer-events: auto;
    }
  }
  .tabs-placeholder {
     .head-wrap {
       margin-right: auto;
      }
      .filter-placeholder {
        margin-left: auto;
        min-width: 150px;
        .ant-popover{
          z-index: 1;
        }
        .tabs-item {
          margin-right: 0px;
        }
      }
  }
  .heading-inner-page {
    .head-wrap {
      display:flex;
      align-items: center;
      .thunder-activity-icon {
        margin-right: 8px;
      }
    }
  }
  .tabs-details {
   margin-top: 16px;
  }
  .article-social-grid, .article-grid {
    width:100%;
  }
  .ant-icon-button {
    background: transparent;
    border:none;
    padding:0px;
    box-shadow: none;
   svg {
     width: 14px;
   }
  }
  .tips-placeholder-spotlight {
    display: flex;
    align-items: center;
  }
  .infinite-scroll-component__outerdiv{
   width: 100%;
  }
  .bottom-social-article {
    margin-top: 15px;
    @media all and (max-width: ${maxTablet}) {
      margin-top: 0px;
    }
  }
  .pulse-leader-div {
    @media all and (max-width: ${midWidthApp}) {
      row-gap: 8px;
    }
    @media all and (max-width: ${maxWidth1300}) and (min-width: ${maxTablet}) {
      margin-top: 20px;
    }
  }
  .feed-container { 
    .boxDoor {
      @media all and (max-width: ${maxTablet}) {
        display: none;
      }
    }
    &.hideBrowserDrawerScroll {
      .boxDoor {
        @media all and (max-width: ${maxTablet}) {
          display: flex;
        }
      }
    }
  }
`;

export default FeedStyle;
